import { useEventTicketSummary } from '~/entities/ticket/model/use-tickets'
import { formatCents } from '~/features/events/tickets/ticket-format'
import * as m from '~/paraglide/messages'

/** What cancelling does, with the money that goes back when the event sold paid tickets. */
export function CancelEventDescription({
  businessId,
  eventId,
}: {
  businessId: string
  eventId: string
}) {
  const summary = useEventTicketSummary(businessId, eventId)
  const gross = summary.data?.grossCents ?? 0
  return (
    <>
      {m.thisWillMarkTheEventAsCanceledAndNotifyAttendees()}
      {gross > 0 ? ` ${m.cancelEventRefunds({ amount: formatCents(gross) })}` : ''}
    </>
  )
}
